import {
  UntypedFormArray,
  UntypedFormControl,
  UntypedFormGroup,
} from "@angular/forms";

// Src: https://loiane.com/2017/08/angular-reactive-forms-trigger-validation-on-submit/
export function validateAllFormFields(
  formGroup: UntypedFormGroup | UntypedFormArray,
) {
  Object.keys(formGroup.controls).forEach((field) => {
    const control = formGroup.get(field);
    if (control instanceof UntypedFormControl) {
      control.markAsTouched({ onlySelf: true });
    } else if (
      control instanceof UntypedFormGroup ||
      control instanceof UntypedFormArray
    ) {
      validateAllFormFields(control);
    }
  });
}
